import React, { Component } from 'react';
import moment from 'moment';
import redirectURL from "../redirectURL";
import Logo from '../../assets/icons/legrand.png';
import { Modal, Button, Form } from 'react-bootstrap';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalAuthConfig';
import { getLandingPage } from '../common/utils';
var images = require.context('../../assets/images/', true);

const emailsWithoutMFA = ["admin@legrand.com", "superadmin@legrand.com", "rpa.cm1@legrand.co.in"];


class Samplepage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            style: {},
            showpass: false,
            email: '',
            password: '',
            isNav: false,
            show: false,
            showModal:false,
            modalTitle:"",
            otp:"",
            otpVerified:false,
            email:"",
            isMsalInitialized: false,
        };
        this.msalInstance = new PublicClientApplication(msalConfig);
    }
    
    cipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);

        return text => text.split('')
            .map(textToChars)
            .map(applySaltToChar)
            .map(byteHex)
            .join('');
    }
    
    encode = this.cipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
    
    decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    // decode = this.decipher("V744c@XBTY!uHWA#v6Fe$GXmx%EXuN&ov(6fkW)x");
    decode = this.decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");

    onSubmitHandler = async (e) => {
        e.preventDefault()
        this.setState({
            show: false,
            style: { display: 'flex' },
            style2: { display: 'none' },
        })
        const emailRegex = /^[^\s@]+@[^\s@]+\.(com|io|in)$/;
        if (!emailRegex.test(this.state.email)) {
            this.setState({
                show: true,
                title: "Invalid Email / Password.",
                style: { display: 'none' },
                style2: { display: 'block' },
            })
            console.error("Invalid email format. The email must contain '@' and end with '.com' or '.in'.");
        } else {
            let md = this.cipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
            let r = md(this.state.email)
            let d = md(this.state.password)
            let params = {
                e: r,
                d: d
            }
            
            await redirectURL.post('/verifyUser', params)
                .then((response) => {

                    if (response.data.status === "success") {                  
                        var decode = this.decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
                        var uData = decode(response.data.output);
                        var user = JSON.parse(uData);
                        this.setState({
                            email: user.email,
                            respOutput: response.data.output,
                            user: user
                        })
                        if(emailsWithoutMFA.includes(user.email)){
                            localStorage.setItem("k", response.data.output);
                            var c = moment.parseZone().format("YYYY-MM-DD")
                            var s = moment.parseZone().format("HH:mm:ss")
                            localStorage.setItem("date", c);
                            localStorage.setItem("time", s);
                            localStorage.setItem("role", this.encode(user.user_type))
                            // localStorage.setItem("role-decoded", user.user_type)
                            localStorage.setItem("dept_code", "SNDG")
                            localStorage.setItem("email", this.encode(user.email))
                            localStorage.setItem("location", user.location_name)
                            localStorage.setItem("transporter", user.transporter_name)
                            localStorage.setItem("entity", user.entity)
                            localStorage.setItem("zone", user.zone)
                            localStorage.setItem("state", user.state)
                            localStorage.setItem("user_id", user.usercode)
                            localStorage.setItem("password_updated_on", user.password_updated_on || "")
                            localStorage.setItem("username",this.encode(user.username || user.user_name ||""))                        
                            if(user.user_type=="admin"){
                                localStorage.setItem("is_admin", user.user_type)
                            }
                            if (user.is_new_user) {
                                localStorage.setItem("is_new_user", user.is_new_user)
                            }
                           
                            this.setState({
                                isNav: true,
                            })
                            
                            window.location.href = getLandingPage(user.user_type);
                        }
                        
                       
                            let params1={
                                email:user.email
                            }
                            this.sendEmailForOtp(params1)
                    }
                    else {
                        this.setState({
                            show: true,
                            title: response.data.message || "Invalid Email / Password.",
                            style: { display: 'none' },
                            style2: { display: 'block' },
                        })
                    }
                }).catch(err => {
                    console.log(err);
                    let message = "Network Error. Please try again later.";
                    if (err.response) {
                        if (err.response.status === 429) {
                            message = err.response.data.error || "Too many login attempts. Please try again later.";
                        } else {
                            message = err.response.data?.error || "Something went wrong. Please try again.";
                        }
                    }
                    console.log(err);
                    this.setState({
                        show: true,
                        title: message,
                        style: { display: 'none' },
                        style2: { display: 'block' },
                    });
                });

        }
    }

    changeInputHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }

    async componentDidMount() {
        await this.msalInstance.initialize(); // Ensure MSAL is initialized before usage
        this.setState({ isMsalInitialized: true });
        setTimeout(function () {
            this.setState({ style: { display: 'none' } });
        }.bind(this), 1000)
    }
    handleCancel = () => {
        this.setState({ showModal: false, otp: '',modalTitle:"" }); // Reset OTP and hide modal
        window.location.href = '/'

      };
    handleSubmit = async() => {
        let params1={
            email: this.state.email,
            otp:this.state.otp
        }
        try {
            const response = await redirectURL.post('/verifyOtp', params1);
            // console.log("Response received:", response);
    
            if (response.data.status === "Success") {
                
                this.setState({ showModal: false, otp: '',modalTitle:"",otpVerified:true });
                let user= this.state.user
                localStorage.setItem("k", this.state.respOutput);
                            var c = moment.parseZone().format("YYYY-MM-DD")
                            var s = moment.parseZone().format("HH:mm:ss")
                            localStorage.setItem("date", c);
                            localStorage.setItem("time", s);
                            localStorage.setItem("role", this.encode(user.user_type))
                            // localStorage.setItem("role-decoded", user.user_type)
                            localStorage.setItem("dept_code", "SNDG")
                            localStorage.setItem("email", this.encode(user.email))
                            localStorage.setItem("location", user.location_name)
                            localStorage.setItem("transporter", user.transporter_name)
                            localStorage.setItem("entity", user.entity)
                            localStorage.setItem("zone", user.zone)
                            localStorage.setItem("state", user.state)
                            localStorage.setItem("user_id", user.usercode)
                            localStorage.setItem("password_updated_on", user.password_updated_on || "")
                            localStorage.setItem("username",this.encode(user.username || user.user_name ||""))                        
                            if(user.user_type=="admin"){
                                localStorage.setItem("is_admin", user.user_type)
                            }
                            if (user.is_new_user) {
                                localStorage.setItem("is_new_user", user.is_new_user)
                            }
                           
                            this.setState({
                                isNav: true,
                            })
                            
                            window.location.href = getLandingPage(user.user_type);


            }else{
                this.setState({ showModal: true, otp: '',modalTitle:"OTP verification failed. Please try again.",otpVerified:false });
            }
        } catch (err) {
            console.error("Error in sendEmailForOtp:", err);
        }
    };
    sendEmailForOtp = async (params1) => {
        console.log("sendEmailForOtp called with params:", params1);
        try {
            const response = await redirectURL.post('/getOtp', params1);
    
            if (response.data.status === "Success") {
                console.log("OTP generation successful, updating state...");
                
                this.setState({
                    showModal: true,
                    modalTitle: "An OTP has been generated and sent to your registered email. Please enter it to proceed with login."
                }, () => {
                    console.log("Updated showModal:", this.state.showModal); // Debugging state update
                });
            }else{
                this.setState({
                    showModal:false,
                    modalTitle:""
                })
            }
        } catch (err) {
            console.error("Error in sendEmailForOtp:", err);
        }
    };
    signInSSO(){
        console.log("this.msalInstance", this.msalInstance)
        this.msalInstance.loginPopup()
        .then(response => {
            this.setState({
                loadshow: 'show-m',
                overly: 'show-m',
                validationMessage: ""
            });
        });

      
    }

    render() {
        let style = this.state.style;
        if (!!localStorage.getItem("k")) {
            if(this.state.otpVerified){
                window.location.href = getLandingPage(this.decode(localStorage.getItem("role")))
            }
        }


        return (
            <div>
                
                <Modal
    show={this.state.showModal}
    onHide={this.handleCancel}
    centered
    backdrop="static"
>
    <Modal.Header className="modal-header-custom">
        <Modal.Title className="modal-title-custom">
            {this.state.modalTitle}
        </Modal.Title>
    </Modal.Header>
    <Modal.Body className="modal-body-custom">
        <Form>
            <Form.Group controlId="otp">
                <Form.Label className="otp-label">Enter OTP</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Enter OTP"
                    className="otp-input"
                    value={this.state.otp}
                    onChange={(e) => this.setState({ otp: e.target.value })}
                    onKeyDown={(e) => {
                        
                        if (e.key === "Enter") {
                            e.preventDefault();
                            
                            // Trigger the submit action when "Enter" is pressed
                            this.handleSubmit(); // Call the handleSubmit function
                        }
                    }}
                />
            </Form.Group>
        </Form>
    </Modal.Body>
    <Modal.Footer className="modal-footer-custom">
        <Button variant="secondary" className="cancel-btn" onClick={this.handleCancel}>
            Cancel
        </Button>
        <Button variant="primary" className="submit-btn" onClick={this.handleSubmit}>
            Submit
        </Button>
    </Modal.Footer>
</Modal>

                {/* Loader starts */}
                {(this.state.showModal !== true) &&
                <div className="loader-wrapper" style={style}>
                    <div className="loader bg-white">
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                        <h4>Have a great day at work today <span>&#x263A;</span></h4>
                    </div>
                </div>}
                {/* Loader ends */}

                {/*page-wrapper Start*/}
                
                <div className="login-bg">
                    <div style={{ paddingLeft: "3rem", paddingTop: "1rem" }}>
                        <img src={Logo} className='logo-left' style={{ width: "15rem" }} />
                    </div>
                    <div className="card mt-4 mb-0 login-form">
                        <div className='login-custom'>
                            <h3 className='pb-3'>Login</h3>
                            {(this.state.show) ?
                                <div className="pb-3 alert alert-danger">{this.state.title}</div>
                                : ""}
                            <form className="theme-form" onSubmit={this.onSubmitHandler} >
                                <div className="form-group">
                                    <label className="col-form-label pt-0">Email</label>
                                    <input required type="text" name='email' className="form-control form-control-lg login-textbox" value={this.state.email} onChange={this.changeInputHandler} />
                                </div>
                                <div className="form-group">
                                    <label className="col-form-label">Password</label>
                                    <input required type={this.state.showpass ? "text" : "password"} name='password' className="form-control form-control-lg login-textbox" value={this.state.password} onChange={this.changeInputHandler} />
                                    {
                                        this.state.showpass ?
                                            <i className="fa fa-eye eye-icon" style={this.state.show ? { top: "62%" } : {}} onClick={() => this.setState(prev => { return { showpass: !prev.showpass } })} /> :
                                            <i className="fa fa-eye-slash eye-icon" style={this.state.show ? { top: "62%" } : {}} onClick={() => this.setState(prev => { return { showpass: !prev.showpass } })} />
                                    }
                                </div>
                                <div className="p-0 " style={{ display: "flex", justifyContent: "end" }}>
                                    <a href='/forgot-password' style={{ color: 'black' }}>Forgot Password?</a>
                                </div>
                                <div className=" login-button">
                                    <button type="submit" className="btn login-textbox login-style">Login
                                    </button>
                                </div>
                                
                                {/* <div className=" login-button">
                                    <button type="button" className="btn login-textbox login-style" onClick={this.signInSSO.bind(this)}>Sign-in with SSO
                                    </button>
                                </div> */}
                            </form>
                        </div>
                        {/* <div className='login-footer' style={{ marginTop: "55px" }}>
										<div className='text-center'>
											<span style={{ fontWeight: "500", marginRight: "10px", fontSize: "14px", fontFamily: "Poppins", verticalAlign: "middle" }}>Powered By</span><img src={require("../../assets/icons/mask_group.png")} style={{ height: "27px" }} />
										</div>
									</div> */}
                    </div>
                  
                </div>
            </div>
        )
    }
}

export default Samplepage;
